import {PriceTypeEnum} from "../../Fields/Core/FBFieldWithPriceBase.Options";
import {FixedAmountCalculator} from "./FixedAmountCalculator";
import {CurrentValueCalculator} from "./CurrentValueCalculator";
import {QuantityCalculator} from "./QuantityCalculator";
import {NoneCalculator} from "./NoneCalculator";
import {PercentageOriginalPriceCalculator} from "./PercentageOriginalPriceCalculator";
import {PercentageOriginalPriceAndOptionsCalculator} from "./PercentageOriginalPriceAndOptionsCalculator";
import {PricePerCharCalculator} from "./PricePerCharCalculator";
import {PricePerWordCalculator} from "./PricePerWordCalculator";
import {CalculatorBase} from "./CalculatorBase";
import {PricePerItemCalculator} from "FormBuilder/Core/Calulators/PricePerItemCalculator";
import {OptionsCalculator} from "FormBuilder/Core/Calulators/OptionsCalculator";
import {formulaCalculator} from "FormBuilder/Core/Calulators/FormulaCalculator";

export class CalculatorFactory {
    public static GetCalculator(type:PriceTypeEnum):CalculatorBase
    {
        switch (type) {
            case PriceTypeEnum.fixed_amount:
                return new FixedAmountCalculator();
            case PriceTypeEnum.current_value:
                return new CurrentValueCalculator();
            case PriceTypeEnum.quantity:
                return new QuantityCalculator();
            case PriceTypeEnum.none:
                return new NoneCalculator();
            case PriceTypeEnum.percent_of_original_price:
                return new PercentageOriginalPriceCalculator();
            case PriceTypeEnum.percent_or_original_price_plus_options:
                return new PercentageOriginalPriceAndOptionsCalculator();
            case PriceTypeEnum.price_per_char:
                return new PricePerCharCalculator();
            case PriceTypeEnum.price_per_word:
                return new PricePerWordCalculator();
            case PriceTypeEnum.price_per_item:
                return new PricePerItemCalculator();
            case PriceTypeEnum.options:
                return new OptionsCalculator();
            case PriceTypeEnum.formula:
                return new formulaCalculator();

        }

    }

}